import React from "react";

export default function ChatListIcon({size = 20, color = "#000000", strokeWidth = 1 }) {
  return (
    <div style={{ textAlign: "center", height: '24px', width: '24px', alignContent: 'center', alignItems: 'center', marginLeft: 2 }} >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-4-1L3 20l1-5.5A8.4 8.4 0 0 1 3 11.5 8.5 8.5 0 0 1 11.5 3 8.5 8.5 0 0 1 21 11.5Z" />
        <line x1="9" y1="8" x2="15" y2="8" />
        <line x1="9" y1="11" x2="15" y2="11" />
        <line x1="9" y1="14" x2="15" y2="14" />
      </svg>
    </div>
  );
}